var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(_vm.activity.activityType, {
          count: _vm.activity.numberOfFiles,
          senderName: _vm.senderName,
          senderFullEmail: _vm.senderFullEmail,
          receiver: _vm.receiver,
          receiverFullEmail: _vm.receiverFullEmail,
          otherReceivers: _vm.otherReceivers
        })
      )}})]),_c('small',[_vm._v(_vm._s(_vm._f("activityDate")(_vm.activity.createdAt)))])])}
var staticRenderFns = []

export { render, staticRenderFns }